import { fleetTrackingServiceClient as client } from '@/api/fleet-tracking/fleetTrackingServiceClient';
import { Trackable } from './types';

async function GetTrackableAssetStates(): Promise<Trackable[]> {
  try {
    const response = await client.get<Trackable[]>('/api/v1/tracking/trackable-assets');

    return response.data;
  } catch (error) {
    Promise.reject(error);
    return [];
  }
}

export default {
  GetTrackableAssetStates
};
